import React, { useState } from "react";
import { Modal, Select, Button, Card, Statistic, Row, Col } from "antd";
import { CalendarOutlined, DollarOutlined } from "@ant-design/icons";
import { update_selected_period } from "../../Controllers/Auth";
import toast from "react-hot-toast";

const PeriodSelectionModal = ({ visible, periods, onClose, onPeriodSelected }) => {
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePeriodSelect = (value) => {
    const period = periods.find(p => p._id === value);
    setSelectedPeriod(period);
  };

  const handleConfirm = async () => {
    if (!selectedPeriod) {
      toast.error("Please select a period");
      return;
    }

    setLoading(true);
    const response = await update_selected_period({
      period_start: selectedPeriod.period_start,
      period_end: selectedPeriod.period_end,
      closing_balance: selectedPeriod.closing_balance,
    });

    if (response?.status) {
      toast.success("Period selected successfully");
      localStorage.setItem("user", response?.data?.token);
      onPeriodSelected(response?.data?.token);
      onClose();
    } else {
      toast.error(response?.message || "Failed to select period");
    }
    setLoading(false);
  };

  const formatPeriod = (period) => {
    const start = new Date(period.period_start).toLocaleDateString();
    const end = new Date(period.period_end).toLocaleDateString();
    return `${start} - ${end}`;
  };

  return (
    <Modal
      title={
        <div className="text-center text-xl font-semibold">
          <CalendarOutlined className="mr-2 text-[#6254be]" />
          Select Accounting Period
        </div>
      }
      open={visible}
      closable={false}
      footer={null}
      width={600}
      centered
    >
      <div className="p-4">
        <p className="text-gray-600 mb-4 text-center">
          Welcome back! Please select the accounting period you want to work with.
        </p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Available Periods
          </label>
          <Select
            size="large"
            placeholder="Select a period"
            className="w-full"
            onChange={handlePeriodSelect}
            options={periods?.map(period => ({
              value: period._id,
              label: formatPeriod(period),
            }))}
          />
        </div>

        {selectedPeriod && (
          <Card className="mb-6 bg-gray-50">
            <Row gutter={16}>
              <Col span={12}>
                <Statistic
                  title="Period Start"
                  value={new Date(selectedPeriod.period_start).toLocaleDateString()}
                  prefix={<CalendarOutlined />}
                />
              </Col>
              <Col span={12}>
                <Statistic
                  title="Period End"
                  value={new Date(selectedPeriod.period_end).toLocaleDateString()}
                  prefix={<CalendarOutlined />}
                />
              </Col>
              <Col span={24} className="mt-4">
                <Statistic
                  title="Opening Balance for this Period"
                  value={`${selectedPeriod.closing_balance?.toLocaleString() || 0}`}
                  valueStyle={{ color: "#6254be" }}
                />
              </Col>
            </Row>
          </Card>
        )}

        <div className="flex gap-3">
          <Button
            size="large"
            className="flex-1"
            onClick={() => {
              onPeriodSelected(null);
              onClose();
            }}
          >
            Skip (Show All)
          </Button>
          <Button
            size="large"
            type="primary"
            className="flex-1 bg-[#6254be]"
            onClick={handleConfirm}
            loading={loading}
            disabled={!selectedPeriod}
          >
            Confirm Period
          </Button>
        </div>

        <p className="text-xs text-gray-400 text-center mt-4">
          You can change the selected period anytime from settings
        </p>
      </div>
    </Modal>
  );
};

export default PeriodSelectionModal;